// Titluri + descrieri SEO per limbă. Funcții pentru paginile cu parametru (departament, legal).
// RO + DE draftate de mine — de revizuit (DE pentru CH).

const SEO = {
  en: {
    home: {
      title: "vorba.dev — Custom software for the work your ERP doesn't do",
      description:
        'vorba.dev builds custom internal tools, integrations and AI for mid-market companies — the spreadsheet-next-to-your-ERP work that NetSuite and off-the-shelf software never quite cover. Two founders, direct. Shipped in weeks.',
    },
    solutions: {
      title: 'Solutions — software for Finance, Operations, Sales, People & Procurement | vorba.dev',
      description:
        'Five places we build custom internal tools, integrations and AI for mid-market companies — wired into NetSuite and the systems you already run.',
    },
    articles: {
      title: 'Articles — vorba.dev',
      description:
        'vorba.dev articles on custom software, internal tools, ERP integrations and AI for mid-market companies.',
    },
    deptTitle: (d) => `${d.label} — custom internal tools & integrations | vorba.dev`,
    deptDescription: (d) =>
      `${d.hero} vorba.dev builds custom ${d.label.toLowerCase()} tools, integrations and AI, wired into the ERP and systems you already run. Shipped in weeks.`,
    legalDescription: (heading) =>
      `${heading} for vorba.dev — custom software, integrations and AI for mid-market companies in the US and Switzerland.`,
  },
  ro: {
    home: {
      title: 'vorba.dev — Software custom & automatizări pentru IMM-uri din RO/CH',
      description:
        'vorba.dev construiește software custom, integrări și automatizări pentru IMM-uri din România și Elveția — unelte interne, dashboard-uri, compliance și AI care se conectează la sistemele pe care le folosești deja. Programează un call de 15 min.',
    },
    solutions: {
      title: 'Soluții — software pentru Finanțe, Operațiuni, Vânzări, Resurse umane & Achiziții | vorba.dev',
      description:
        'Cinci locuri unde construim software custom, integrări și automatizări pentru IMM-uri din RO și CH — conectate la uneltele pe care le folosești deja.',
    },
    articles: {
      title: 'Articole — vorba.dev',
      description:
        'Articole vorba.dev despre software custom, automatizări și reglementări (e-Factura, SAF-T, REGES) pentru IMM-uri din RO și CH.',
    },
    deptTitle: (d) => `${d.label} — software custom pentru IMM-uri din RO și CH | vorba.dev`,
    deptDescription: (d) =>
      `${d.hero} vorba.dev construiește unelte, integrări și automatizări custom pentru ${d.label.toLowerCase()}, conectate la sistemele pe care le folosești deja.`,
    legalDescription: (heading) =>
      `${heading} pentru vorba.dev — software custom & automatizări pentru IMM-uri din România și Elveția.`,
  },
  de: {
    home: {
      title: 'vorba.dev — Massgeschneiderte Software, die Ihre Insellösungen verbindet',
      description:
        'vorba.dev baut massgeschneiderte interne Tools und Integrationen für Schweizer KMU — verbindet bexio, Abacus, das CRM und das Excel dazwischen. Ihnen gehörend, kein Lock-in. In Wochen geliefert.',
    },
    solutions: {
      title: 'Lösungen — Software für Finanzen, Betrieb, Vertrieb, Personal & Einkauf | vorba.dev',
      description:
        'Fünf Bereiche, in denen wir massgeschneiderte interne Tools, Integrationen und KI für Schweizer KMU bauen — verbunden mit bexio, Abacus und den Tools, die Sie schon nutzen.',
    },
    articles: {
      title: 'Artikel — vorba.dev',
      description:
        'vorba.dev-Artikel zu massgeschneiderter Software, internen Tools, Integrationen und KI für Schweizer KMU.',
    },
    deptTitle: (d) => `${d.label} — massgeschneiderte Software für Schweizer KMU | vorba.dev`,
    deptDescription: (d) =>
      `${d.hero} vorba.dev baut massgeschneiderte ${d.label}-Tools, Integrationen und KI, verbunden mit bexio, Abacus und dem Stack, den Sie schon nutzen.`,
    legalDescription: (heading) =>
      `${heading} für vorba.dev — massgeschneiderte Software & Automatisierung für KMU in Rumänien und der Schweiz.`,
  },
}

export function getSeo(locale = 'en') {
  return SEO[locale] || SEO.en
}
